// extracted by mini-css-extract-plugin
export default {"cls1":"GDyRp8Nqb5ck7HAGMMdO","cls2":"oxv3aZ0jgo9gc94p1KmW GDyRp8Nqb5ck7HAGMMdO"};